module.exports = Object.assign(
  require('./Production.json'),
  {
    alias: ['stl'],
    visibility: true,
    image: '/img/workflows/Production.png',
    defaultItems: {
      // 'SIGFRM': 1
    },
    orderStatuses: require('../OrderStatuses.js'),
    tabs: [
      //require('./Tab0-MasterData.js'),
      require('./Tab1-STL.js'),
      require('./Tab2-Attachments.js'),
      //require('./Tab3-Addons.js'),
      require('./Tab4-Cart.js'),
    ],

    productTree: require('../ProductTree.js'),
  }
);
